<template>
  <div>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.0-2/css/all.min.css" integrity="sha256-46r060N2LrChLLb5zowXQ72/iKKNiw/lAmygmHExk/o=" crossorigin="anonymous" />
    <b-container>
      <b-row id="contacts">
        <b-col md="6">
          <b-card img-src="/bilder/kontakt/thomas-einsiedler.jpg" img-alt="Einsiedler Thomas" img-top class="contactPerson">
            <b-card-text>
              <b class="name">Thomas Einsiedler</b><br>
              <span class="role">Gesch&auml;ftsf&uuml;hrer</span><br><br>
              <i class="fas fa-phone"></i> +43 (0)7241 | 28148
              <br>
              <b-icon icon="envelope-fill"></b-icon> office(at)ezw.at
            </b-card-text>
          </b-card>
        </b-col>
        <b-col md="6">
          <b-card img-src="/bilder/kontakt/christian-zandomeneghi.jpg" img-alt="Zandomeneghi Christian" img-top class="contactPerson">
            <b-card-text>
              <b class="name">Christian Zandomeneghi</b><br>
              <span class="role">Gesch&auml;ftsf&uuml;hrer</span><br><br>
              <i class="fas fa-phone"></i> +43 (0)7241 | 28148
              <br>
              <b-icon icon="envelope-fill"></b-icon> cz(at)ezw.at
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="data" md="6">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2664.3648190699496!2d13.966620315512388!3d48.103197761533956!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4773f186168a7ce9%3A0xf8d72309ef1cf7e0!2sEZW%20Werkzeugbau%20GmbH!5e0!3m2!1sde!2sat!4v1591282793052!5m2!1sde!2sat"
            aria-hidden="false" tabindex="0" id="map"></iframe>
        </b-col>
        <b-col class="data" md="6">
          <b-card border-variant="primary" header="Kontakt" header-bg-variant="primary" header-text-variant="light" id="contact">
            <b-card-text>
              <b-icon icon="geo-alt"></b-icon> A-4652 Fischlham, Seebach 6
              <br>
              <i class="fas fa-phone"></i> +43 (0)7241 | 28148
              <br>
              <b-icon icon="envelope-fill"></b-icon> office(at)ezw.at
              <br>
              <b-icon icon="laptop"></b-icon> <a href="http://www.ezw.at">www.ezw.at</a>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="downRow">
        <b-col class="headerDown" md="4">
          <div class="text"><h2><b>Downloads</b></h2></div>
        </b-col>
        <b-col class="dataDown" md="8">
          <br>
          <b-table show-empty small stacked="md" :items="visibleItems()" :fields="fields" striped>
            <template v-slot:cell(name)="row">
              {{row.item.name}}
            </template>

            <template v-slot:cell(actions)="row">
              <a :href="'/downloads/' + row.item.filename" download>
                <b-button size="sm" class="mr-1" variant="primary">
                  Download
                </b-button>
              </a>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      data: {},
      fields: [
          { key: 'name', label: 'Datei', sortable: false },
          { key: 'actions', label: 'Link' }
        ]
    }
  },
    mounted() {
        axios.get('/konfiguration/kontakt.json').then((response) => {
            this.data = response.data
        }).catch((err)=>{this.test=err});
    },
  methods: {
    visibleItems: function () {
      return this.data.items.filter(function(item) {return item.visible == true;});
    }
  }
}
</script>

<style scoped>
.headerDown {
  min-height: 150px;
}

.row {
  margin-right: 0px;
  margin-left: 0px;
}

.dataDown {
  padding: 0;
  padding-top: 10px;
}

.text {
  width: 100%;
  height: 100%;
  text-align: center;
  display: table;
}

*>>> th {
  border-top: none!important;
}

.headerDown h2 {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.table {
  color: white;
}

* >>>.downRow {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  color: white!important;
  background-color: #363636;
}

.downRow > [class*='col-'] {
  display: flex;
  flex-direction: column;
}

#map {
  width: 92%;
  border: none;
  height: 92%;
  border: 3px outset black;
  margin: 3.5%;
}

@media only screen and (max-width: 768px) {
  #map {
    width: 100%;
    height: 100%;
    margin: 0%;
  }
}

#contact {
  width: 70%;
  height: 50%;
  position: absolute;
  top: 25%;
  left: 15%;
}

#contacts {
  background-image: linear-gradient(to bottom, #dedede, #efefef);
}

@media only screen and (min-width: 992px) {
  .contactPerson {
    width: 60%;
    position: relative;
    left: 20%;
    top: 10%;
    margin-bottom: 20%;
  }
} 

@media only screen and (max-width: 992px) {
  .contactPerson {
    width: 75%;
    position: relative;
    left: 12.5%;
    top: 10%;
    margin-bottom: 20%;
  }

  #contact {
    height: 45%;
    top: 27.5%;
  }
} 

.data {
  height: 468px;
  background-color: #dedede;
  padding: 0!important;
}

a, a:active {
  color: black;
  text-decoration: underline;
}

a:hover {
  color: #676767;
}

.role {
  font-style: italic;
}

.name {
  font-size: 24px;
}

.card-header {
  font-size: 24px;
  font-weight: bold;
}

.contactPerson > img {
  height: 300px;
  object-fit: cover;
  object-position: 100% 15%;
}
</style>